import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["addButton", "removeButton", "quantity"]

	async addToBasket(e) {
		e.preventDefault()
		const self = this
		const response = await fetch('/basket', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': document.querySelector( 'meta[name="csrf-token"]' ).getAttribute("content")
			},
			body: JSON.stringify({
				item_id: self.data.get("item-id"),
				item_type: self.data.get("item-type"),
				quantity: self.quantityTarget.value
			})
		})

		const data = JSON.parse(await response.text())

		// Check for error response
		if (!response.ok) {
			// Show error notification
			let notification = document.createElement("div")
			notification.className = "notification toast is-danger"
			notification.innerHTML = data.error || "Could not add item to basket"
			let closeButton = document.createElement("button")
			closeButton.className = "delete"
			closeButton.addEventListener('click', () => {
				notification.parentNode.removeChild(notification)
			})
			notification.appendChild(closeButton)
			this.element.closest('.container').prepend(notification)
			setTimeout(() => {
				if (notification.parentNode) {
					notification.parentNode.removeChild(notification)
				}
			}, 5000)
			return
		}

		// Success - update basket UI
		const basket = data
		const basket_icon_text = document.getElementById('basket-icon-text')
		const basket_icon = document.getElementById('basket-icon')
		basket_icon_text.textContent = "Basket (" + basket.length + ")"
		basket_icon.style.visibility = "visible"
		const navbar_end = document.getElementById('navbar-end')
		navbar_end.style.display = "contents"

		// Update mobile basket icon
		const basket_icon_text_mobile = document.getElementById('basket-icon-text-mobile')
		const navbar_end_mobile = document.getElementById('navbar-end-mobile')
		if (basket_icon_text_mobile) basket_icon_text_mobile.textContent = "Basket (" + basket.length + ")"
		if (navbar_end_mobile) { navbar_end_mobile.style.display = ""; navbar_end_mobile.style.marginLeft = "auto" }

		// If this is a one-per-customer item, disable the button immediately
		const isOnePerCustomer = self.element.dataset.productOnePerCustomer === "true"
		if (isOnePerCustomer) {
			const addButton = self.addButtonTarget

			// Replace the link with a disabled button
			const disabledButton = document.createElement('button')
			disabledButton.className = 'button is-light is-small'
			disabledButton.textContent = 'Already in basket'
			disabledButton.disabled = true
			addButton.parentNode.replaceChild(disabledButton, addButton)

			// Hide just the quantity selector element, not the whole column
			if (self.hasQuantityTarget) {
				self.quantityTarget.style.visibility = 'hidden'
			}
		}

		// show confirmation notification
		let notification = document.createElement("div")
		notification.className = "notification toast is-art"
		notification.innerHTML = "Item added to <a href='/customers/basket'>basket</a>."
		let closeButton = document.createElement("button")
		closeButton.className = "delete"
		closeButton.addEventListener('click', () => {
			notification.parentNode.removeChild(notification)
		})
		notification.appendChild(closeButton)
		this.element.closest('.container').prepend(notification)
		setTimeout(() => {
			if (notification.parentNode) {
				notification.parentNode.removeChild(notification)
			}
		}, 5000)
	}

	async removeFromBasket(e) {
		e.preventDefault()
		const self = this
		fetch('/basket/' + self.data.get("item-id"), {
			method: 'DELETE',
			headers: {
				'X-CSRF-TOKEN': document.querySelector( 'meta[name="csrf-token"]' ).getAttribute("content")
			}
		})
			.then(response => response.json())
			.then(data => {
				if(data.length == 0) {
					// redirect to homepage if basket is empty
					Turbolinks.visit('/')
				} else {
					Turbolinks.visit(window.location)
				}
			})
	}

	createAvailabilityRequest(e) {
		e.preventDefault()
		const wl_modal = document.querySelector('#availability-request-modal')
		const item_id = this.data.get("item-id")
		const item_type = this.data.get("item-type")
		wl_modal.setAttribute('data-item-id', item_id)
		wl_modal.setAttribute('data-item-type', item_type)
		wl_modal.classList.add('is-active')
	}

	deleteAvailabilityRequest(e) {
		e.preventDefault()
		const wl_modal = document.querySelector('#availability-request-cancel-modal')
		const item_id = this.data.get("item-id")
		const item_type = this.data.get("item-type")
		wl_modal.setAttribute('data-item-id', item_id)
		wl_modal.setAttribute('data-item-type', item_type)
		wl_modal.classList.add('is-active')
	}
	
	connect() {
		
	}
}
